import { Reveal } from "../site/Reveal";

const AMBITS = [
  {
    code: "[ AMBITO 01 ]",
    title: "Opere di Condomini",
    text: "Manutenzioni straordinarie e rifacimenti per stabili condominiali, gestite direttamente con amministratori e condomini.",
    items: ["Rifacimento facciate e tetti", "Cappotti termici e efficientamento", "Parti comuni e balconi"],
  },
  {
    code: "[ AMBITO 02 ]",
    title: "Ristrutturazioni Appartamenti",
    text: "Ristrutturazioni complete chiavi in mano di appartamenti privati, con un unico interlocutore dal sopralluogo alla consegna.",
    items: ["Impianti e bagni", "Pavimenti e finiture", "Preventivi chiari e puntuali"],
  },
  {
    code: "[ AMBITO 03 ]",
    title: "Lavori Pubblici & Appalti SOA",
    text: "Partecipazione a bandi e affidamenti per enti e stazioni appaltanti, con gestione burocratica e tecnica completa.",
    items: ["Qualificazione SOA OG 1 cl. II", "SAL e contabilità puntuale", "Rispetto rigido dei capitolati"],
  },
];

export const TechAmbits = () => (
  <section id="specializzazioni" data-testid="ambits-section" className="py-20 bg-slate-50 border-b border-slate-200">
    <div className="max-w-7xl mx-auto px-6">
      <Reveal>
        <div className="max-w-3xl mb-14">
          <span className="text-xs font-mono uppercase tracking-widest text-blue-600">Ambiti di Intervento</span>
          <h2 className="text-xl sm:text-3xl font-extrabold uppercase text-slate-950 mt-1 mb-3 [overflow-wrap:anywhere]">Capacità Operativa Multidisciplinare</h2>
          <p className="text-slate-600 text-sm leading-relaxed">
            Dai condomini agli appartamenti privati, fino alle gare pubbliche: Saircos dispone delle competenze
            interne per governare ogni snodo realizzativo.
          </p>
        </div>
      </Reveal>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {AMBITS.map((a, i) => (
          <Reveal key={a.code} delay={i * 0.08}>
            <div data-testid={`ambit-card-${i}`} className="h-full p-8 bg-white border border-slate-200 shadow-sm hover:shadow-md transition-shadow">
              <div className="text-xs font-mono font-bold text-blue-600 mb-3">{a.code}</div>
              <h3 className="text-lg font-bold text-slate-900 uppercase mb-3">{a.title}</h3>
              <p className="text-slate-600 text-xs leading-relaxed mb-4">{a.text}</p>
              <ul className="text-xs text-slate-500 space-y-1 font-mono">
                {a.items.map((it) => (
                  <li key={it}>• {it}</li>
                ))}
              </ul>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
